import { useNetworkValidation } from '@hooks';
import { NetworkModal } from '@/components/modals/NetworkModal';

export const NetworkValidator = () => {
  const {
    isWrongNetwork,
    currentChainId,
    expectedChainId,
    networkName,
    switchNetwork,
    canSwitchNetwork,
  } = useNetworkValidation();

  return (
    <NetworkModal
      isOpen={isWrongNetwork}
      networkName={networkName}
      currentChainId={currentChainId}
      expectedChainId={expectedChainId}
      onSwitchNetwork={switchNetwork}
      canSwitchNetwork={canSwitchNetwork}
    />
  );
};
